import { render, staticRenderFns } from "./CreateReview.vue?vue&type=template&id=34c7fe61&scoped=true"
import script from "./CreateReview.vue?vue&type=script&lang=js"
export * from "./CreateReview.vue?vue&type=script&lang=js"
import style0 from "./CreateReview.vue?vue&type=style&index=0&id=34c7fe61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c7fe61",
  null
  
)

export default component.exports